import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';

import {useCustomerMgr, useProducts} from 'coreHooks';

import FlyoutToggleButton from 'brandComponents/flyouts/FlyoutToggleButton';
import Icon from 'brandComponents/Icon';
import Link from 'brandComponents/Link';
import {useWishlist} from 'brandHooks';

import messages from './messages';

import styles from './CustomerServiceLinks.module.scss';

const CustomerServiceLinks = () => {
	const intl = useIntl();
	const CustomerMgr = useCustomerMgr();
	const customer = CustomerMgr.getCurrentCustomer();
	const {items} = useWishlist();
	const products = useProducts(items.map(i => i.productId));
	const wishlistProducts = products.filter(p => !p.isOffline());

	const buttonWishlist = useMemo (() => (
		<div className={styles['customer-service-links__wishlist']}>
			<div className={styles['customer-service-links__wishlist-totals']}>
				<Icon name="wishlist-false" height={20} width={20} />
				{wishlistProducts?.length > 0 && (
					<div className={styles['customer-service-links__wishlist-totals-count']}>
						<span>{wishlistProducts?.length}</span>
					</div>
				)}
			</div>

			<span>{intl.formatMessage(messages.wishlist)}</span>
		</div>
	), [wishlistProducts]);

	const buttonLogin = useMemo (() => (
		<div className={styles['customer-service-links__login']}>
			<Icon name="account-regular" height={20} width={20} />
			<span>{intl.formatMessage(messages.login)}</span>
		</div>
	), []);

	return (
		<div className={styles['customer-service-links']}>
			<div className={styles['customer-service-links__flyouts']}>
				{!customer.isRegistered &&
					<FlyoutToggleButton buttonContent={buttonLogin} flyoutId="login" dataIds={{'data-type': 'my-account'}} />
				}
				{customer.isRegistered &&
					<Link to="/myaccount" data-type="my-account">
						<Icon
							name="account-regular-fill"
							title={intl.formatMessage(messages.myAccount)}
							height={20}
							width={20}
						/>
						<span>{intl.formatMessage(messages.myAccount)}</span>
					</Link>
				}
				<FlyoutToggleButton buttonContent={buttonWishlist} flyoutId="wishlist" dataIds={{'data-type': 'wishlist'}} />
			</div>
			<div className={styles['customer-service-links__links']}>
				<Link to="/stores" className={styles['store-locator']}>
					<Icon name="store" height={20} width={20} />
					<span>{intl.formatMessage(messages.findInStore)}</span>
				</Link>
			</div>
		</div>
	);
};

export default CustomerServiceLinks;
